function request(url) {
  return new Promise((resolve, reject) => {
    let xhr = new XMLHttpRequest();
    xhr.addEventListener("load", function() {
      if (xhr.status < 200 || xhr.status > 299) {
        reject(xhr.statusText);
        xhr.dispatchEvent(new Event("error"));
        return;
      }
      try {
        resolve(JSON.parse(xhr.response));
      } catch (ex) {
        reject(ex);
      }
    });
    xhr.addEventListener("error", e => {
      reject(e);
    });
    xhr.open("GET", url, true);
    xhr.send();
  });
}

export default request;
